export const getPurchaseItems = (purchase) => {
  if (!purchase) return [];
  if (Array.isArray(purchase.purchaseItems) && purchase.purchaseItems.length) {
    return purchase.purchaseItems;
  }
  if (Array.isArray(purchase.PurchaseItems) && purchase.PurchaseItems.length) {
    return purchase.PurchaseItems;
  }
  return [];
};
